import React from 'react';

const Content = props => (
    <div className="microsite-contents content-wrapper">
        {props.children}
    </div>
);

export default Content;


// WEBPACK FOOTER //
// ./src/Content.js